import { useEffect } from 'react'
import { useSearchParams } from 'react-router'
import { useGlobalFiltersStore } from './useGlobalFiltersStore'
import { useHomeFiltersStore } from './usehomeFiltersStore'

const STORE_ID_PARAM = 'storeId'
const CHANNEL_PARAM = 'channel'
const AGGREGATION_PARAM = 'aggregation'
const TEAM_ID_PARAM = 'teamId'

const isChannel = (value: string | null): value is 'INSTORE' | 'OMNI' => value === 'INSTORE' || value === 'OMNI'

const isAggregation = (value: string | null): value is 'STORE' | 'TEAM' => value === 'STORE' || value === 'TEAM'

/**
 * Synchronize filters between store and URL query parameters.
 */
export const useHomeFiltersUrlSync = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const storeId = useGlobalFiltersStore(state => state.storeId)
  const channel = useHomeFiltersStore(state => state.channel)
  const aggregation = useHomeFiltersStore(state => state.aggregation)
  const teamId = useHomeFiltersStore(state => state.teamId)
  const setStoreId = useGlobalFiltersStore(state => state.setStoreId)
  const setChannel = useHomeFiltersStore(state => state.setChannel)
  const setAggregation = useHomeFiltersStore(state => state.setAggregation)
  const setTeamId = useHomeFiltersStore(state => state.setTeamId)

  useEffect(() => {
    const urlStoreId = searchParams.get(STORE_ID_PARAM)
    const urlChannel = searchParams.get(CHANNEL_PARAM)
    const urlAggregation = searchParams.get(AGGREGATION_PARAM)
    const urlTeamId = searchParams.get(TEAM_ID_PARAM)

    if (urlStoreId !== null) {
      const parsedStoreId = Number.parseInt(urlStoreId, 10)
      if (!Number.isNaN(parsedStoreId)) setStoreId(parsedStoreId)
    }
    if (isChannel(urlChannel)) setChannel(urlChannel)
    if (isAggregation(urlAggregation)) setAggregation(urlAggregation)
    if (urlTeamId !== null) {
      const parsed = Number.parseInt(urlTeamId, 10)
      if (!Number.isNaN(parsed)) setTeamId(parsed)
    }
  }, [])

  useEffect(() => {
    setSearchParams(
      prev => {
        const next = new URLSearchParams(prev)
        if (storeId === null) {
          next.delete(STORE_ID_PARAM)
        } else {
          next.set(STORE_ID_PARAM, String(storeId))
        }
        next.set(CHANNEL_PARAM, channel)
        next.set(AGGREGATION_PARAM, aggregation)
        if (teamId === null) {
          next.delete(TEAM_ID_PARAM)
        } else {
          next.set(TEAM_ID_PARAM, String(teamId))
        }
        return next
      },
      { replace: true }
    )
  }, [storeId, aggregation, channel, teamId, setSearchParams])
}
